// extracted by mini-css-extract-plugin
module.exports = {"winner":"MatchcardTab_winner__10XIM","trophy":"MatchcardTab_trophy__24eoL"};